<template>
  <div class="animated fadeIn">
    <div class="loading" v-if="loading">
      <square-loader :loading="true" color="#26A65B" size="50px"></square-loader>
    </div>

    <b-card>
      <b-row>
        <b-col cols='12' sm="7">
          <b-form-group v-bind:label="$t('outlet')" :label-cols="2" label-class="text-right" :horizontal="true">
            <v-select v-model="outlet" :options="outlets[$session.get('lang')]">
            </v-select>
          </b-form-group>
        </b-col>
        <b-col cols='12' sm="3">
          <b-form-group v-bind:label="$t('date')" :label-cols="2" label-class="text-right" :horizontal="true">
            <date-range-picker
              :startDate="start_date"
              :endDate="end_date"
              @update="updateDate"
              :locale-data="locale"
            >
            </date-range-picker>
          </b-form-group>
        </b-col>
        <b-col cols='12' sm="2">
          <b-button variant="success" v-on:click="refresh"> <i class="fa fa-search"></i> {{$t('search')}}</b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-row>
      <b-col sm="6" lg="6">
        <table class="table" v-if="best_sale_data != null" >
          <tr v-for="(item, index) in best_sale_data" >
            <td>
              <span class="badge" :style="'background-color: ' + item.color">{{item.name}}</span>
            </td>
            <td :style="'font-weight: 600; color: ' + item.color">{{item.total}}</td>
          </tr>
        </table>
      </b-col>
      <b-col sm="6" lg="6">
        <doughnut :labels="best_sale_labels" :datasets="best_sale_datasets"/>
        <div class="full-width text-center bg-gray-100 chart-title">
          <h2>{{$t('top_10')}}</h2>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<style scoped>
  .chart-title {
    color: #6c6c6c;
    padding: 5px;
  }
  .loading {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.9);
    z-index: 99999;
    padding-top: 300px;
  }
</style>
<script>
import DateRangePicker from 'vue2-daterange-picker'
import Doughnut from './charts/Doughnut'
import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import {best_sale, store} from '@/api/report'

export default {
  name: 'ProductMix',
  components: {
    DateRangePicker,
    Doughnut,
    SquareLoader,
    datePicker
  },
  data: function () {
    return {
      loading: true,
      date: new Date(),
      date_picker_options: {
        format: 'DD/MM/YYYY',
        useCurrent: true
      },
      start_date: this.$moment().subtract(6, 'day').format('YYYY-MM-DD'),
      end_date: this.$moment().format('YYYY-MM-DD'),
      locale: {
        format: 'DD/MM/YYYY',
        separator: ' - '
      },
      outlets: [],
      outlet: {
        label: this.$auth.user().store_code,
        value: this.$auth.user().store_code
      },
      languages: Object.keys(this.$i18n.messages),
      pie_data: {
        backgroundColor: [
          '#20a8d8',
          '#f86c6b',
          '#ffc107',
          '#4dbd74',
          '#73818f',
          '#17A589',
          '#EB984E',
          '#9B59B6',
          '#34495E',
          '#D98880'
        ],
        data: []
      },
      best_sale_data: [],
      best_sale_labels: [],
      best_sale_datasets: {}
    }
  },
  methods: {
    updateOutlet (val) {
      this.outlet = val
    },
    /**
     * Update data
     */
    updateData () {
      this.$Progress.start()
      let params = {
        outlet_code: this.outlet.value,
        from_date: this.start_date,
        to_date: this.end_date,
        top: 10
      }
      best_sale(params).then((response) => {
        this.best_sale_labels = []
        this.best_sale_datasets[0].data = []
        this.best_sale_data = []
        for (let i in response.data.data) {
          let data = response.data.data[i]
          this.best_sale_labels.push(data.menu_name)
          this.best_sale_datasets[0].data.push(data.total)
          this.best_sale_data.push({
            name: data.menu_name,
            total: data.total,
            color: this.pie_data.backgroundColor[i]
          })
        }
      }).catch((error) => {
        this.$notify({
          title: this.$t('error'),
          text: error.response.data.message,
          type: 'error'
        })
      }).then(() => {
        this.loading = false
        this.$Progress.finish()
      })
    },
    /**
     * Refresh data
     */
    refresh () {
      this.updateData()
    },
    /**
     * Update Date
     */
    updateDate (val) {
      this.start_date = this.$moment(val.startDate).format('YYYY-MM-DD')
      this.end_date = this.$moment(val.endDate).format('YYYY-MM-DD')
      this.refresh()
    }
  },
  created: function () {
    let bestSaleData = this._.cloneDeep(this.pie_data)
    this.best_sale_datasets = [bestSaleData]
    this.$Progress.start()
    store().then((response) => {
      this.outlets = {}
      for (let l in this.languages) {
        this.outlets[this.languages[l]] = []
        this.outlets[this.languages[l]].push({
          label: this.$t('all', this.languages[l]),
          value: null
        })
        for (let i in response.data.data) {
          this.outlets[this.languages[l]].push({
            label: response.data.data[i].name,
            value: response.data.data[i].store_code
          })

          if (this.outlet.value == response.data.data[i].store_code) {
            this.outlet.label = response.data.data[i].name
          }
        }
      }

      this.refresh()

      setInterval(() => {
        this.refresh()
      }, 5 * 60 * 1000)
    }).catch((error) => {
      this.$notify({
        title: this.$t('error'),
        text: error.response.data.message,
        type: 'error'
      })
    }).then(() => {
      this.$Progress.finish()
    })
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ProductMix.vue